import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Rule, User } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/error-handling/error-handling.service";
import { API_ENDPOINTS } from "../user-management-endpoints";

interface GetUsersResponse {
  users: User[];
}

interface GetUserResponse {
  user: User;
}

@Injectable({
  providedIn: "root",
})
export class UserService {
  private readonly userUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) { }

  getUsers(currentPage: number, organizationId: string): Observable<User[]> {
    return this.http
      .post<GetUsersResponse>(`${this.userUrl}${API_ENDPOINTS.USER.FETCH}`, {
        currentPage,
        organizationId
      })
      .pipe(
        map((response) => response.users),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getInitialUsers(
  organizationId: string
) {
  return this.getUsers(0, organizationId);
}

  getUserSearch(
    currentPage: number,
    searchText: String,
    filterByHeader: String,
    organizationId: string
  ): Observable<User[]> {
    return this.http
      .post<GetUsersResponse>(`${this.userUrl}${API_ENDPOINTS.USER.SEARCH}`, {
        currentPage,
        searchText,
        filterByHeader,
        organizationId
      })
      .pipe(
        map((response) => response.users),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  createUser(
    firstName: string,
    lastName: string,
    email: string,
    role: string,
    username: string,
    password: string,
    organizationId: string
  ): Observable<User> {
    return this.http
      .post<User>(`${this.userUrl}${API_ENDPOINTS.USER.CREATE}`, {
        firstName,
        lastName,
        email,
        role,
        username,
        password,
        organizationId
      })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  updateUser(
    userId: string,
    firstName: string,
    lastName: string,
    email: string,
    role: string,
    username: string,
    password: string,
    organizationId: string
  ): Observable<User> {
    return this.http
      .post<User>(`${this.userUrl}${API_ENDPOINTS.USER.UPDATE}`, {
        userId,
        firstName,
        lastName,
        email,
        role,
        username,
        password,
        organizationId
      })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getUser(userId: string, organizationId: string): Observable<User> {
    return this.http
      .post<GetUserResponse>(`${this.userUrl}${API_ENDPOINTS.USER.GET}`, {
        userId,
        organizationId
      })
      .pipe(
        map((response) => response.user),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteUser(userId: string, username: string): Observable<User> {
    return this.http
      .post<User>(`${this.userUrl}${API_ENDPOINTS.USER.DELETE}`, { userId, username })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }
}
